/* less/lib/less-node/environment */ function _(require, module, exports) {
    module.exports = {
        encodeBase64: function encodeBase64(str) {
            return new Buffer(str).toString('base64');
        },
        mimeLookup: function (filename) {
            return require(260) /* mime */.lookup(filename);
        },
        charsetLookup: function (mime) {
            return require(260) /* mime */.charsets.lookup(mime);
        },
        getSourceMapGenerator: function getSourceMapGenerator() {
            return require(324) /* source-map */.SourceMapGenerator;
        }
    };
}
